import type { TeamData } from "robotevents";

export const filterTeams = (
	teams: TeamData[],
	filter: string | null,
): TeamData[] => {
	if (!filter) return teams;

	return teams?.filter(
		(team) =>
			team.number.startsWith(filter) ||
			team.team_name?.toUpperCase().includes(filter) ||
			team.organization?.toUpperCase().includes(filter) ||
			team.location?.country?.toUpperCase().includes(filter) ||
			team.location?.region?.toUpperCase().includes(filter) ||
			team.location?.city?.toUpperCase().includes(filter),
	);
};
